var map = {
	"./c-multiple-files.computation-template.json": 84768,
	"./c.computation-template.json": 43396,
	"./case1.computation-template.json": 54185,
	"./container-all-ui-elements.computation-template.json": 27425,
	"./container-helloworld.computation-template.json": 79284,
	"./container-parameter.computation-template.json": 80657,
	"./container-simple-ui.computation-template.json": 47507,
	"./container.computation-template.json": 34235,
	"./example-docu-1-template.json": 1783,
	"./example-docu-2-template.json": 59998,
	"./hello-world.docker-container-example.json": 21489,
	"./leap-year.computation-template.json": 14712,
	"./parameter-ini.computation-template.json": 23096,
	"./teacher-frontend-test.json": 70070,
	"./test.json": 56986,
	"./viplab-computation-template.json": 99986,
	"./workshop-bash-example.computation-template.json": 56351,
	"./workshop-snakemake-example.computation-template.json": 94303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87848;